import axios from 'axios';

import {
  resolveExternalEndpointProxyUrl,
  resolveExternalEndpointUrl,
  shouldProxyExternalDrupalView,
} from '@powdr/utils';

import { NODE_PENDING, NODE_SUCCESS, NODE_ERROR } from '../types';

export const getExternalNodeData = (endpoint) => async (dispatch, getState) => {
  const { node } = getState();

  dispatch({
    type: NODE_PENDING,
    payload: [],
  });

  if (!node.node[endpoint]) {
    try {
      // Node paths like `/content/pressreleases` stay on the site's Node API.
      // Drupal view endpoints go through the Node proxy when ENABLE_EXTERNAL_DRUPAL_VIEW_PROXY is true.
      const url = shouldProxyExternalDrupalView(endpoint)
        ? resolveExternalEndpointProxyUrl(endpoint)
        : resolveExternalEndpointUrl(endpoint);
      const res = await axios.get(url);
      dispatch({
        type: NODE_SUCCESS,
        payload: {
          [endpoint]: res.data,
        },
      });
    } catch (error) {
      dispatch({
        type: NODE_ERROR,
        payload: error,
      });
    }
  }
};
